var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgPlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customer_organization_ic",
    "data-name": "customer organization_ic",
    transform: "translate(-101 -97.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7374",
    "data-name": "Rectangle 7374",
    transform: "translate(101 97.995)",
    fill: "#fff",
    stroke: "#52b0d9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 92,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "business-and-trade",
    transform: "translate(124.981 121.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11496",
    "data-name": "Path 11496",
    d: "M24.922,3.414,3.9.22A3.39,3.39,0,0,0,1.186.966,3.42,3.42,0,0,0,0,3.529v40.3a1.918,1.918,0,0,0,1.913,1.913H8.129V35.7a3.339,3.339,0,0,1,3.347-3.347h4.782A3.339,3.339,0,0,1,19.6,35.7V45.741h8.129V6.723a3.349,3.349,0,0,0-2.812-3.309Zm-14.4,24.635H7.651a1.434,1.434,0,1,1,0-2.869h2.869a1.434,1.434,0,0,1,0,2.869Zm0-5.738H7.651a1.434,1.434,0,1,1,0-2.869h2.869a1.434,1.434,0,0,1,0,2.869Zm0-5.738H7.651a1.434,1.434,0,0,1,0-2.869h2.869a1.434,1.434,0,0,1,0,2.869Zm0-5.738H7.651a1.434,1.434,0,1,1,0-2.869h2.869a1.434,1.434,0,0,1,0,2.869Zm9.563,17.214H17.214a1.434,1.434,0,0,1,0-2.869h2.869a1.434,1.434,0,0,1,0,2.869Zm0-5.738H17.214a1.434,1.434,0,0,1,0-2.869h2.869a1.434,1.434,0,0,1,0,2.869Zm0-5.738H17.214a1.434,1.434,0,0,1,0-2.869h2.869a1.434,1.434,0,0,1,0,2.869Zm0-5.738H17.214a1.434,1.434,0,0,1,0-2.869h2.869a1.434,1.434,0,0,1,0,2.869Z",
    transform: "translate(0)",
    fill: "#1c97cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11497",
    "data-name": "Path 11497",
    d: "M29.118,12.2,15.5,9.351V37.369H28.41a3.351,3.351,0,0,0,3.347-3.347V15.473A3.331,3.331,0,0,0,29.118,12.2ZM24.585,31.631H21.716a1.434,1.434,0,1,1,0-2.869h2.869a1.434,1.434,0,0,1,0,2.869Zm0-5.738H21.716a1.434,1.434,0,1,1,0-2.869h2.869a1.434,1.434,0,1,1,0,2.869Zm0-5.738H21.716a1.434,1.434,0,1,1,0-2.869h2.869a1.434,1.434,0,1,1,0,2.869Z",
    transform: "translate(14.146 8.372)",
    fill: "#1c97cf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgPlaceholder);
export default __webpack_public_path__ + "static/media/org_placeholder.0f896b7aef7f691fafc161a8aaeb26a9.svg";
export { ForwardRef as ReactComponent };